export const LOCAL_STORAGE_DEVICEID = 'device-id'
export const LOCAL_STORAGE_AUTHTOKEN = 'auth-token'
export const LOCAL_STORAGE_REFRESHTOKEN = 'refresh-token'
export const LOCAL_STORAGE_RENEWTOKEN_STATUS = 'refresh-token-status'
